import { useState } from "react";
import {
  SignRequest,
  useVbsWorkOrderSignMutation,
} from "@/services/backend/vbs/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { SignatureDialog } from "@/services/backend/signature/components/signature-dialog";
import t from "@/lang/lang";

export function SignatureButton(props: { workOrderID: string }) {
  const { workOrderID } = props;
  const [request, setRequest] = useState<SignRequest>({
    id: workOrderID,
    signature: "",
    dataFormat: "image/svg+xml:base64",
    nameOfSigner: "",
  });
  const mutation = useVbsWorkOrderSignMutation();
  useDebouncedMutation(
    request,
    setRequest,
    mutation,
    {
      id: workOrderID,
      signature: "",
      dataFormat: "image/svg+xml:base64",
      nameOfSigner: "",
    },
    { delay: 0 },
  );

  return (
    <SignatureDialog
      title={t("Arbeitsschein bestätigen")}
      name=""
      onConfirm={(data) => {
        setRequest({
          ...request,
          signature: data.signature,
          nameOfSigner: data.name,
        });
      }}
    />
  );
}
